import {Card, Col, Row, Space, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringBrandAnalysisType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {VisibilitySignalRow} from './visibility-signal-row';
import * as styles from './visibility-signals.scss';

type PropsType = {
    analysis: AiMonitoringBrandAnalysisType;
};

export function VisibilitySignals(props: PropsType): JSX.Element {
    const {analysis} = props;
    const {signals} = analysis.visibility;
    const {sources} = analysis;

    return (
        <Card size="small" title={<Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__VISIBILITY_TITLE" />}>
            <Row gutter={[8, 0]}>
                {signals.map((signal) => (
                    <Col key={signal.key} md={12} xs={24}>
                        <VisibilitySignalRow signal={signal} />
                    </Col>
                ))}
            </Row>

            {sources.length > 0 ? (
                <div className={styles.visibility_signals__sources}>
                    <Typography.Text className={styles.visibility_signals__sources_label} type="secondary">
                        <Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__SOURCES" />:
                    </Typography.Text>
                    <Space size={[8, 4]} wrap>
                        {sources.map((source) => (
                            <Typography.Text className={styles.visibility_signals__source} key={source}>
                                {source}
                            </Typography.Text>
                        ))}
                    </Space>
                </div>
            ) : null}
        </Card>
    );
}
